<template>
  <div class="button-footer">
    <CButton variant="outline" name="save" color="primary" @click="back">Back</CButton>
    <CButton variant="outline" v-show="!data.id" name="save" color="success" @click="save">Save</CButton>
    <CButton variant="outline" v-show="data.id" name="save" color="success" @click="update">Update</CButton>
  </div>
</template>
<script>
export default {
  props: ["data"],
  methods: {
    back() {
      this.$emit("back");
    },
    save() {
      this.$emit("save");
    },
    update() {
      this.$emit("update");
    },
  },
};
</script>